/**
 * 签署拦截器组件
 * 包裹受保护路由，在用户有待签署协议时显示签署弹窗
 */

import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { useConsentCheck } from "@/hooks/useConsentCheck";
import { useConsentStore } from "@/stores/consentStore";
import ConsentModal from "./ConsentModal";

interface ConsentInterceptorProps {
  children?: React.ReactNode;
}

/**
 * 签署拦截器
 *
 * 功能：
 * - 包裹需要保护的路由
 * - 在用户有待签署协议时显示签署弹窗
 * - 强制更新协议时自动打开弹窗
 * - 支持作为路由布局组件使用（使用 Outlet）
 */
export default function ConsentInterceptor({
  children,
}: ConsentInterceptorProps) {
  const { hasForceUpdate } = useConsentCheck();
  const { isModalOpen, openModal } = useConsentStore();

  // 如果有强制更新协议且弹窗未打开，自动打开
  useEffect(() => {
    if (hasForceUpdate && !isModalOpen) {
      openModal();
    }
  }, [hasForceUpdate, isModalOpen, openModal]);

  return (
    <>
      {children || <Outlet />}
      <ConsentModal />
    </>
  );
}
